"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
//import { Link } from 'react-router-dom';
const mobx_react_1 = require("mobx-react");
const mobx_1 = require("mobx");
const Store_1 = require("../Store");
let BrandBox = class BrandBox extends React.Component {
    onClick() {
        if (this.props.hasShortcutUrl) {
            Store_1.default.SelectedBrand = this.props;
            //store.SelectedProduct = null;
            //store.SelectedSubcategory = null;
            $([document.documentElement, document.body]).scrollTop(0);
            window.location.href = this.props.url;
        }
        else {
            Store_1.default.SelectedBrand = this.props;
            Store_1.default.loadProducts();
            $([document.documentElement, document.body]).animate({
                scrollTop: 0
            }, Store_1.default._scrollspeed);
        }
    }
    render() {
        const numberOfProductsText = `${this.props.numberOfProducts} ${Store_1.default.Translations.numberOfProductsText}`;
        return (React.createElement("a", { href: this.props.url, onClick: this.onClick, className: "o-product-brand-wrapper col-xs-6 col-sm-4 col-md-3 col-lg-2 u-mb-3" },
            React.createElement("div", { style: { backgroundImage: "url(" + this.props.listingImageUrl + "?height=800&quality=70" + ")" }, className: "o-product-brand-container" },
                React.createElement("div", { className: "filter" })),
            React.createElement("h3", { className: "u-mt-05 u-mb-0" }, this.props.name),
            React.createElement("h3", { className: "u-mb-0 u-mt-0" }, numberOfProductsText))
        //<Link to={this.props.url} onClick={this.onClick} className="o-product-brand-wrapper col-xs-6 col-sm-4 col-md-3 col-lg-2 u-mb-3">
        //    <div style={{ backgroundImage: "url(" + this.props.listingImageUrl + "?height=800&quality=70" + ")" }} className="o-product-brand-container">
        //        <div className="filter" />
        //    </div>
        //    <h3 className="u-mt-05 u-mb-0">{this.props.name}</h3>
        //    <h3 className="u-mb-0 u-mt-0">{numberOfProductsText}</h3>
        //</Link>    
        );
    }
};
__decorate([
    mobx_1.action.bound
], BrandBox.prototype, "onClick", null);
BrandBox = __decorate([
    mobx_react_1.observer
], BrandBox);
exports.default = BrandBox;
